import { render, staticRenderFns } from "./PillPaginationNav.vue?vue&type=template&id=604c239b"
import script from "./PillPaginationNav.vue?vue&type=script&lang=js"
export * from "./PillPaginationNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports